import { PropsWithChildren } from 'react'
import { Text } from '@chakra-ui/react'

export const SectionHeading = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Text as="h2" textAlign="left" lineHeight={1} fontSize={{ base: 'lg', md: '2xl' }} fontWeight="normal">
      {children}
    </Text>
  )
}

export const SectionHeadingCentered = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Text as="h2" textAlign="center" lineHeight={1} fontSize={{ base: 'lg', md: '2xl' }} fontWeight="normal">
      {children}
    </Text>
  )
}
